import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bulletList'
})
export class BulletListPipe implements PipeTransform {
  transform(value: string, bulletChar: string = '•', separator: string = ','): string {
    if (!value) return '';

    return value
      .split(separator)
      .map(item => `${bulletChar} ${item.trim()}`)
      .join('\n');
  }
}
